import { motion } from 'motion/react';

type Data = {
  legend: string;
  name: string;
  visible: boolean;
  color: { default: string; hover: string };
};

interface LegendProps {
  data: Data;
  onClick: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  visibleCount: number;
  dashStyle?: string;
  shape?: 'circle' | 'line';
  disabled?: boolean;
}

const Legend = ({
  data,
  onClick,
  onMouseEnter,
  onMouseLeave,
  visibleCount,
  dashStyle,
  shape = 'line',
  disabled = false,
}: LegendProps) => {
  return (
    <li className='flex items-center'>
      <motion.button
        type='button'
        className='focus-visible:ring-ring flex items-center gap-1 rounded-md transition-opacity duration-300
          focus-visible:ring-2 focus-visible:outline-hidden enabled:hover:opacity-50 disabled:cursor-not-allowed
          disabled:opacity-30'
        animate={{ opacity: disabled ? 0.3 : data.visible ? 1 : 0.5 }}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        disabled={disabled || (visibleCount === 1 && data.visible)}
      >
        {shape === 'circle' ? (
          <span
            className='rounded-full'
            style={{
              backgroundColor: data.color.default,
              width: '0.375rem',
              height: '0.375rem',
            }}
          />
        ) : (
          <svg
            aria-hidden='true'
            width={'20'}
            height={'8'}
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d={'M0 4 H20'}
              stroke={data.color.default}
              strokeDasharray={dashStyle}
              strokeWidth={1.5}
              fill='none'
            />
          </svg>
        )}
        <span className='text-sm whitespace-nowrap'>{data.legend}</span>
      </motion.button>
    </li>
  );
};

export default Legend;
